import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsEmployee from "graphql/fields/FieldsEmployee";
import FieldsCreditAmount from 'graphql/fields/FieldsCreditAmount';

const fields = {
	'guid': 'String!',
};

export default gql(`
	query employee( ${ HelperGraphql.createFields( fields ) } ) {
		employee( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsEmployee}
			transport_kind
			external_id
			verified
			
			user {
				guid
				active
				kind
				
				rights{
					user_right
					active
				}
			}
			
			team {
				guid
			}
			
			department {
				guid
			}
			
			jobtitle {
				guid
			}
			
			address {
				name
				postal_code
				locality
				country
				is_valid
			}

			credit_amounts {
				${ FieldsCreditAmount }
			}
		}
	}
`);

